import { Routes } from '@angular/router';
import { UnifiedResponseFormComponent } from './features/response/unified-response.form';
import { WeddingInfoFinalComponent } from './features/details/wedding-info-final';
import { PolterabendFinalComponent } from './features/polterabend/polterabend-final';
import { ContactFinalComponent } from './features/contact/contact-final';
import { StandardPage } from './core/auth/pages/standard';
import { LoginPage } from './core/auth/pages/login';
import { authGuard } from './core/auth/guards/auth.guard';
import { fullAccessGuard, polterabendAccessGuard } from './core/auth/guards/access.guard';
import { defaultRedirectGuard } from './core/auth/guards/redirect.guard';

// WHY: Clean routing with only final components for production use
export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: StandardPage,
    children: [
      {
        path: 'form', component: UnifiedResponseFormComponent,
        // canActivate: [polterabendAccessGuard]
      },
      {
        path: 'details', component: WeddingInfoFinalComponent,
        // canActivate: [fullAccessGuard]
      },
      {
        path: 'polter', component: PolterabendFinalComponent,
        // canActivate: [polterabendAccessGuard]
      },
      {
        path: 'contact', component: ContactFinalComponent,
        // canActivate: [polterabendAccessGuard]
      },
      { path: '', pathMatch: 'full', canActivate: [defaultRedirectGuard], children: [] },
    ]
  },
  { path: 'login', component: LoginPage },
  { path: '**', redirectTo: 'login' },
];
